import { render, staticRenderFns } from "./BuyerSales.vue?vue&type=template&id=77932563&scoped=true&"
import script from "./BuyerSales.vue?vue&type=script&lang=js&"
export * from "./BuyerSales.vue?vue&type=script&lang=js&"
import style0 from "./BuyerSales.vue?vue&type=style&index=0&id=77932563&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77932563",
  null
  
)

export default component.exports